import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {TagModule} from 'primeng/tag';
import {ReputationService} from './reputation.service';
import {ReputationRules, ReputationRank} from './reputation.models';

@Component({
  selector: 'app-reputation-rank',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, TagModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *ngIf="(rank?.id || rankId) && slug">
      <ng-container *ngIf="rank; else rankFromRules">
        <ng-container *ngTemplateOutlet="rankTag; context: {$implicit: rank}"></ng-container>
      </ng-container>
      <ng-template #rankFromRules>
        <ng-container *ngIf="rules$ | async as rules">
          <ng-container *ngIf="definition(rules) as definition">
            <ng-container *ngTemplateOutlet="rankTag; context: {$implicit: definition}"></ng-container>
          </ng-container>
        </ng-container>
      </ng-template>
    </ng-container>
    <ng-template #rankTag let-value>
      <a [routerLink]="navigationEnabled ? ['/', slug, 'reputation'] : null" (click)="open($event)"
         [attr.role]="navigationEnabled ? null : 'button'" [attr.tabindex]="navigationEnabled ? null : 0"
         (keydown.enter)="onKeydown($event)" (keydown.space)="onKeydown($event)"
         [attr.aria-label]="'reputation.rank_link' | translate:{rank: ('reputation.ranks.' + value.id | translate)}">
        <p-tag [value]="'reputation.ranks.' + value.id | translate" [icon]="value.icon" [severity]="value.severity" [rounded]="true"></p-tag>
      </a>
    </ng-template>
  `,
})
export class ReputationRankComponent {
  @Output() readonly opened = new EventEmitter<void>();
  @Input() rankId: string | null | undefined;
  @Input() rank: ReputationRank | null | undefined;
  @Input() slug: string | null | undefined;
  @Input() navigationEnabled = true;
  public readonly rules$ = this.reputation.rules$.pipe(catchError(() => of(null)));
  constructor(private readonly reputation: ReputationService) {}
  public open(event: Event): void {
    if (!this.navigationEnabled) event.preventDefault();
    event.stopPropagation();
    this.opened.emit();
  }
  public onKeydown(event: Event): void {
    if (!this.navigationEnabled) this.open(event);
  }
  public definition(rules: ReputationRules): ReputationRank | undefined { return rules.ranks.find(rank => rank.id === this.rankId); }
}
